module.exports = __webpack_public_path__ + "media/images/twitter2-327968fc40b7b3a4f045631dd65a9b6e.png";